import { camelizeKeys } from 'humps';
import { ihubPost } from '@namespace/helpers';

export const getShopItems = (props) =>
  ihubPost('/ihub/api/v1/shop/item/get', props)
    .then(camelizeKeys)
    .then(({ data, status }) => (status ? data : []));
